import React from "react";

export default function Book(props) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="16" height="12.364" viewBox="0 0 16 12.364">
			<path
				id="ic_import_contacts_24px"
				d="M15.545,4.864A8.585,8.585,0,0,0,13,4.5,6.764,6.764,0,0,0,9,5.591,6.764,6.764,0,0,0,5,4.5,6.764,6.764,0,0,0,1,5.591V16.245a.391.391,0,0,0,.364.364c.073,0,.109-.036.182-.036A8.877,8.877,0,0,1,5,15.773a6.764,6.764,0,0,1,4,1.091,8.76,8.76,0,0,1,4-1.091,7.4,7.4,0,0,1,3.455.764.328.328,0,0,0,.182.036A.391.391,0,0,0,17,16.209V5.591A4.96,4.96,0,0,0,15.545,4.864Zm0,9.818A8.451,8.451,0,0,0,13,14.318a8.76,8.76,0,0,0-4,1.091V7.045a8.76,8.76,0,0,1,4-1.091,8.451,8.451,0,0,1,2.545.364Z"
				transform="translate(-1 -4.5)"
				fill="#d7a44d"
			/>
		</svg>
	);
}

export function BookLg() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="83" height="64">
			<path
				d="M75.455 1.882A44.624 44.624 0 0 0 62.25 0C54.893 0 46.97 1.506 41.5 5.647 36.03 1.506 28.107 0 20.75 0S5.47 1.506 0 5.647V60.8a2.026 2.026 0 0 0 1.886 1.882c.377 0 .566-.188.943-.188a46.129 46.129 0 0 1 17.92-4.141c7.357 0 15.28 1.506 20.75 5.647 5.093-3.2 14.336-5.647 20.75-5.647 6.225 0 12.639 1.129 17.92 3.953a1.7 1.7 0 0 0 .943.188A2.026 2.026 0 0 0 83 60.612V5.647a25.754 25.754 0 0 0-7.545-3.765Zm0 50.824a43.927 43.927 0 0 0-13.2-1.882c-6.414 0-15.657 2.447-20.75 5.647V13.176c5.093-3.2 14.336-5.647 20.75-5.647a43.927 43.927 0 0 1 13.2 1.882Z"
				fill="#d7a44d"
			/>
		</svg>
	);
}
